import { AppState } from '../../app/state/AppState';
import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';

export function selectContentSort(state: AppState): ReadonlyArray<IOrderClause> {
  return state.order.order;
}

export function selectContentSortIgnoreNextUrlChange(state: AppState): boolean {
  return state.order.ignoreNextUrlChange;
}
